import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  },
  label: {
    fontSize: 14,
    paddingLeft: 12,
    color: theme.palette.text.primary
  },
  /**
   * Strips the browser's default button chrome, nothing more.
   *
   * Declared HERE, above the selectedDateValueContainer* rules, on purpose:
   * JSS emits rules in key order, so anything those containers set — border,
   * padding, height, colour — wins the tie and the six existing consumers
   * render exactly as they did when this was a div. The reset only reaches
   * properties none of them set, and the borderless ForFilter variant keeps
   * `border: 0` because that variant is borderless by design.
   *
   * `textAlign: start` rather than `left`: a button centres its text by
   * default, and this panel renders right-to-left in Persian.
   */
  valueButton: {
    appearance: 'none',
    background: 'none',
    border: 0,
    margin: 0,
    font: 'inherit',
    color: 'inherit',
    textAlign: 'start',
    cursor: 'pointer'
  },
  input: {
    padding: '16px 12px',
    backgroundColor: 'transparent !important',
    outline: 'none',
    border: `1px solid ${theme.palette.grey[900]}`,
    borderRadius: 6,
    transition: 'all 0.25s linear',
    width: '100%',
    '&:focus': {
      borderColor: theme.palette.grey[900]
    }
  },
  inputContainer: {
    position: 'relative',
    width: '100%'
  },
  inputSmall: {
    padding: '11px 12px',
    height: 40
  },
  helpertext: {
    minHeight: 24
  },
  error: {
    color: theme.palette.error.dark
  },
  inputError: {
    borderColor: theme.palette.error.dark
  },
  fullWidth: {
    width: '100%'
  },
  startIconContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: 49,
    width: 49,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  inputWithStartIcon: {
    paddingLeft: 56
  },
  inputHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 6
  },
  rightHeader: {
    paddingRight: 12
  },
  datePickerContainer: {
    position: 'absolute',
    zIndex: 10000,
    top: 28,
    // Logical, not physical. This panel renders right-to-left in Persian, and
    // a popup pinned to the visual left of a field whose content now starts on
    // the right reads as belonging to neither. The rest of this stylesheet is
    // still physical; those are pre-existing and belong in their own change.
    insetInlineStart: 0
  },
  selectedDateValueContainer: {
    padding: '11px 12px',
    height: 49,
    border: `1px solid ${theme.palette.grey[600]}`,
    width: '100%',
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center'
  },
  disabled: { opacity: 0.5 },
  selectedDateValueContainerForFilter: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    marginLeft: 2,
    fontSize: 13,
    lineHeight: '30px',
    fontWeight: 600,
    color: theme.palette.text.secondary
  },
  selectedDateValueContainerSmall: {
    height: 40
  }
}))

export default useStyles
